import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-links">
            <button 
              className="footer-link"
              onClick={() => setShowPrivacyModal(true)}
            >
              Privacy Policy
            </button>
            <span className="footer-separator">|</span>
            <button 
              className="footer-link"
              onClick={() => setShowTermsModal(true)}
            >
              Terms of Use
            </button>
          </div>
          <p className="footer-text">
            Copyright 2001-2026 Accenture. All rights reserved. Accenture Confidential. For internal use only.
          </p>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {showPrivacyModal && (
        <div className="modal-overlay" onClick={() => setShowPrivacyModal(false)}>
		 <div className="footer-privacy-content">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Privacy Policy</h2>
              <button className="modal-close" onClick={() => setShowPrivacyModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <h3>Data Privacy Statement</h3>
              <p>Please be aware that any personal data that you and others provide through this tool may be processed by Accenture.</p>

              <p>The protection of your personal data is very important to Accenture. Accenture is committed to keeping your personal data secure, and processing it in accordance with applicable data protection laws and our internal policies including our <a href="https://www.accenture.com/us-en/about/privacy-policy" target="_blank" rel="noopener noreferrer">Global Data Privacy Policy</a>.</p>

              <p>Before providing any personal data through this tool, Accenture invites you to read its <a href="https://www.accenture.com/us-en/about/privacy-policy" target="_blank" rel="noopener noreferrer">privacy statement</a>, which includes important information on why and how Accenture is processing your personal data.</p>
            </div>
            <div className="modal-footer">
              <button className="modal-agree-button" onClick={() => setShowPrivacyModal(false)}>I Agree</button>
            </div>
          </div>
		  </div>
        </div>
      )}

      {/* Terms of Use Modal */}
      {showTermsModal && (
        <div className="modal-overlay" onClick={() => setShowTermsModal(false)}>
		<div className="footer-term-content">
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Terms of Use</h2>
              <button className="modal-close" onClick={() => setShowTermsModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <h3>Acceptance of Terms</h3>
              <p>By accessing and using Language Buddy, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use this platform.</p>

              <h3>License and Access</h3>
              <p>Language Buddy grants you a limited, non-exclusive, non-transferable license to access and use the platform for personal language learning purposes. This license does not include any rights to modify, distribute, or create derivative works.</p>

              <h3>User Conduct</h3>
              <p>You agree to use Language Buddy in accordance with all applicable laws and regulations. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>

              <h3>Intellectual Property</h3>
              <p>All content, materials, features, and functionality available on Language Buddy, including but not limited to text, graphics, logos, and software, are the property of Accenture and are protected by copyright, trademark, and other intellectual property laws.</p>

              <h3>Disclaimer of Warranties</h3>
              <p>Language Buddy is provided "as is" without warranties of any kind, either express or implied. We do not guarantee that the platform will be error-free, uninterrupted, or free from harmful components.</p>

              <h3>Limitation of Liability</h3>
              <p>To the maximum extent permitted by law, Accenture shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of Language Buddy.</p>

              <h3>Modifications to Terms</h3>
              <p>We reserve the right to modify these Terms of Use at any time. Your continued use of the platform following any changes constitutes acceptance of those changes.</p>

              <h3>Termination</h3>
              <p>We may terminate or suspend your access to Language Buddy at any time, without prior notice, for conduct that we believe violates these Terms of Use or is harmful to other users, us, or third parties.</p>

              <h3>Governing Law</h3>
              <p>These Terms of Use shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.</p>
            </div>
            <div className="modal-footer">
              <button className="modal-agree-button" onClick={() => setShowTermsModal(false)}>I Agree</button>
            </div>
          </div>
		  </div>
        </div>
      )}
    </>
  );
};

export default Footer;
